import type { CSSProperties } from 'react';
import styles from './SplitLegend.module.css';

export interface SplitLegendProps {
  items: { label: string; color: string }[];
}

/** Compact inline key under a SplitBar: "■ TV 41%  ■ Movies 59%". */
export function SplitLegend({ items }: SplitLegendProps) {
  return (
    <span className={styles.legend}>
      {items.map((item) => (
        <span key={item.label} className={styles.item}>
          <span className={styles.swatch} style={{ '--color': item.color } as CSSProperties} />
          {item.label}
        </span>
      ))}
    </span>
  );
}
